export default __webpack_public_path__ + "static/media/myself.b0adaf0b.png";